export const environment = {
  production: false,
  //apiUrl: 'https://lacpoint.com.br/bck',
  apiUrl: 'https://back-dev.vps6003.panel.icontainer.run',
  wordpressUrl: 'https://lacpoint.com.br',
  tutoriaisUrls: {
    tutorialToken: '/tutorial-token/',
    tutorialGestaoDeRotas: '/tutorial-gestao-de-rotas/'
  },
  apiKey: 'chave-dev-api',
  pkExameCCS: 2,
  pkExameCPP: 8,
  pkExameProteina: 4,
  pkExameGordura: 3,
  modeloLacpoint: 280, //Id do modelo de bonificação da lacpoint,
  lacpointLaticinioId: 4 //Id do usuário lacpoint do tipo laticínio
};
